export const isFunction = (entity: unknown): entity is Function => typeof entity === 'function'
